import { useEffect, useState } from "react";
import { Auditores, Cronograma, PlanAI } from "../../interfaces/PlanesInterface"
import { Users } from "../../interfaces/UserInterface";
import { API_AUDITORIAS } from "../../features/constants";
import { Alerta, Confirm, Toast } from "../../features/toast";
import "../../App";

interface PlanAIProps{
    plan: PlanAI | undefined
    update: Boolean 
    setUpdate: React.Dispatch<React.SetStateAction<boolean>>
    setSelectPlan?: React.Dispatch<React.SetStateAction<PlanAI | undefined>>
}

export const PlanAuditoriaInterna = ({plan,update,setUpdate,setSelectPlan}:PlanAIProps)=>{
    
    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;

    const [auditores, setAuditores] = useState<Auditores[]>([]);
    const [cronograma, setCronograma] = useState<Cronograma[]>([]);
    const [actualizar, setActualizar] = useState(false);

    const [lugar, setLugar] = useState("");
    const [fecha, setFecha] = useState("");
    const [numero_auditoria, setNumero_auditoria] = useState("");
    const [objetivo, setObjetivo] = useState("");
    const [alcance, setAlcance] = useState("");
    const [criterios, setCriterios] = useState("");

    const [nombreNuevo, setNombreNuevo] = useState("");
    const [funcionNuevo, setFuncionNuevo] = useState("");

    const [fechaNuevo, setFechaNuevo] = useState("");
    const [horaNuevo, setHoraNuevo] = useState("");
    const [capitulo_normaNuevo, setCapitulo_normaNuevo] = useState("");
    const [tema_procesoNuevo, setTema_procesoNuevo] = useState("");
    const [interlocutoresNuevo, setInterlocutoresNuevo] = useState("");

    useEffect(()=>{
        if(plan && plan.Id !== ""){
            setLugar(plan.Lugar.toString());
            setFecha(plan.Fecha.toString());
            setNumero_auditoria(plan.Nro_auditoria.toString());
            setObjetivo(plan.Objetivo.toString());
            setAlcance(plan.Alcance.toString());
            setCriterios(plan.Criterios.toString());
        }else{
            setLugar("");
            setFecha("");
            setNumero_auditoria("");
            setObjetivo("");
            setAlcance("");
            setCriterios("");
        }
    },[plan]);

    useEffect(()=>{
        //buscar los auditores y el cronograma en la base de datos
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id: plan?.Id
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Lista-de-Auditores-Plan",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:Auditores[])=>{
                setAuditores(data);
            })
        
        fetch(API_AUDITORIAS + "/Lista-Cronograma-Plan",init)
            .then(resp=>resp.json())
            .catch(error=>console.log(error))
            .then((cron:Cronograma[])=>{
                setCronograma(cron);
            })
    },[plan?.Id,actualizar])

    const nuevoAuditor = ()=>{
        let aud = {
            Id : "",
            Id_Plan: "",
            Nombre: "",
            Funcion: ""
        }
        setAuditores([...auditores,aud])
    }

    const guardarAuditor = ()=>{//Guarda los datos del auditor en la base de datos
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_Plan: plan?.Id,
                Nombre: nombreNuevo,
                Funcion: funcionNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Agregar-Auditor-Plan",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Auditor Agregado",
                        text:"Se agrego el auditor correctamente"
                    })
                    setActualizar(!actualizar);
                    setNombreNuevo("");
                    setFuncionNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar el Auditor",
                        text:"No se pudeo agregar el auditor"
                    })
                }
            })
    }

    const eliminarAuditor = (id:string)=>{//Elimina el auditor que ya esta guardado en la base de datos
        Confirm.fire({
            icon:"question",
            title:"Eliminar Auditor",
            text:"¿Desea Eliminar el Auditor Seleccionado?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Eliminar-Auditor-Plan",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Auditor Eliminado",
                                text:"Se elimino el auditor correctamente"
                            })
                            setActualizar(!actualizar);
                            setNombreNuevo("");
                            setFuncionNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Auditor",
                                text:"No se pudeo eliminar el auditor"
                            })
                        }
                    })
                    }
        })
        
    }

    const cancelarNuevoAuditor = ()=>{//Descarta los datos del auditor que aun no se guardo en la base de datos
        setNombreNuevo("");
        setFuncionNuevo("");
        setAuditores(auditores.slice(0,auditores.length-1));
    }


    const nuevoCronograma = ()=>{
        let cron = {
            Id:"",
            Id_Plan:"",
            Fecha:"",
            Hora:"",
            Capitulo_norma:"",
            Tema_proceso:"",
            Interlocutores:""
        }

        setCronograma([...cronograma,cron]);
    }

    const cancelarCronograma = ()=>{//Descarta los datos del cronograma
        setFechaNuevo("");
        setHoraNuevo("");
        setCapitulo_normaNuevo("");
        setTema_procesoNuevo("");
        setInterlocutoresNuevo("");
        setCronograma(cronograma.slice(0,cronograma.length-1));
    }

    const guardarCronograma = ()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
                Id_Plan: plan?.Id,
                Fecha: fechaNuevo,
                Hora: horaNuevo,
                Capitulo_norma: capitulo_normaNuevo,
                Tema_proceso: tema_procesoNuevo,
                Interlocutores: interlocutoresNuevo
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Cronograma-Plan",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Id){
                    Toast.fire({
                        icon:"success",
                        title:"Cronograma Agregado",
                        text:"Se agrego el cronograma correctamente"
                    })
                    setActualizar(!actualizar);
                    setFechaNuevo("");
                    setHoraNuevo("");
                    setCapitulo_normaNuevo("");
                    setTema_procesoNuevo("");
                    setInterlocutoresNuevo("");
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Error al Agregar el Cronograma",
                        text:"No se pudeo agregar el cronograma"
                    })
                }
            })

    }

    const eliminarCronograma = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Actividad",
            text:"¿Desea Eliminar la Actividad del Cronograma?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Cronograma-Plan",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Cronograma Eliminado",
                                text:"Se elimino el Cronograma correctamente"
                            })
                            setActualizar(!actualizar);
                            setFechaNuevo("");
                            setHoraNuevo("");
                            setCapitulo_normaNuevo("");
                            setTema_procesoNuevo("");
                            setInterlocutoresNuevo("");
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Cronograma",
                                text:"No se pudeo eliminar el Cronograma"
                            })
                        }
                    })
            }
        })
    }


    const guardarPlan = ()=>{
        //envía los datos del plan a la base de datos
        let planActual = {
                Id: plan?plan.Id:"",
                Lugar: lugar,
                Fecha: fecha,
                Nro_auditoria: numero_auditoria,
                Objetivo: objetivo,
                Alcance: alcance,
                Criterios: criterios
            }
        let init = {
            method: plan?.Id===""?"POST":"PUT",
            body: JSON.stringify(planActual),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUDITORIAS + "/Plan-Auditoria-Interna",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data)=>{
                if(data?.Mensaje === "Ok"){
                    Toast.fire({
                        icon:"success",
                        title:"Plan de Auditoría Interna",
                        text:"Datos Actualizados Correctamente"
                    })
                    setActualizar(!actualizar);
                    setUpdate(!update);
                    if (setSelectPlan){
                        planActual.Id = data.Id;
                        setSelectPlan(planActual);
                    }
                }else{
                    Toast.fire({
                        icon:"error",
                        title:"Plan de Auditoría Interna",
                        text:"No se logró actualizar los datos"
                    })
                }
            })
    }



    const eliminarPlan = (id:string)=>{
        Confirm.fire({
            icon:"question",
            title:"Eliminar Plan de Auditoría Interna",
            text:"¿Desea Eliminar de manera Permanente el plan de Auditoría?",
            confirmButtonText:"Eliminar",
            confirmButtonColor:"red"
        }).then(response=>{
            if(response.value === true){
                let init = {
                    method: "DELETE",
                    body: JSON.stringify({
                        Id: id
                    }),
                    header:{
                        "Content-Type":"aplication/json"
                    }
                };
                fetch(API_AUDITORIAS + "/Plan",init)
                    .then(response=>response.json())
                    .catch(err=>console.log(err))
                    .then((data)=>{
                        if(data?.Mensaje ==="Ok"){
                            Toast.fire({
                                icon:"success",
                                title:"Plan de Auditoría Interna Eliminado",
                                text:"Se elimino correctamente el plan de auditoría"
                            })
                            if(setSelectPlan)
                                setSelectPlan(undefined);
                            setUpdate(!update);
                        }else{
                            Toast.fire({
                                icon:"error",
                                title:"Error al Eliminar el Plan de Auditoría Interna",
                                text:"No se pudeo eliminar el plan de auditoría Interna"
                            })
                        }
                    })
            }
        })
    }


    return(
        <div className="m-1">
            <h3 className="titulo">Plan de Auditoría Interna</h3>
            <div
                className="row justify-content-center align-items-top g-2"
            >
                <div className="col-8">
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Lugar</label>
                        <textarea
                            value={lugar}
                            disabled={user.Auditoria!=="2"?true:false}
                            title={lugar===""?"Doble click para cargar el lugar del plan anterior":""}
                            className="form-control"
                            rows={2}
                            placeholder={plan?.Lugar?.slice(0,20)+"..."}
                            onDoubleClick={()=>setLugar(plan?plan.Lugar.toString():"")}
                            onChange={(e)=>setLugar(e.target.value)}
                        >
                        </textarea>
                        {
                            user.Auditoria==="2"?<>
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Nombre de la Organización y dirección donde se realizará la auditoría</small>
                            </>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                <div className="col-2">
                    <div className="mb-3">
                        <label htmlFor="fecha-plan" className="form-label">Fecha</label>
                        <input
                            value={fecha}
                            disabled={user.Auditoria!=="2"?true:false}
                            type="date"
                            className="form-control"
                            name="fecha-plan"
                            id="fecha-plan"
                            aria-describedby="helpId"
                            onChange={(e)=>setFecha(e.target.value)}
                        />
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Fecha planificada para el inicio de la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                </div>
                <div className="col-2">
                    <div className="mb-3">
                        <label htmlFor="nro-auditoria" className="form-label">Auditoría Nº</label>
                        <input
                            value={numero_auditoria}
                            disabled={user.Auditoria!=="2"?true:false}
                            type="text"
                            className="form-control"
                            name="nro-auditoria"
                            id="nro-auditoria"
                            aria-describedby="helpId"
                            onChange={(e)=>setNumero_auditoria(e.target.value)}
                        />
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Número correspondiente a la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                </div>
            </div>
            
            <div
                className="row justify-content-center align-items-top g-2"
            >
                <div className="col">
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Objetivo</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="" 
                            id="" 
                            rows={3} 
                            value={objetivo}
                            title={objetivo===""?"Doble click para cargar el objetivo del plan anterior":""}
                            aria-describedby="helpId"
                            placeholder={plan?.Objetivo?.slice(0,20)+"..."}
                            onDoubleClick={()=>setObjetivo(plan?plan.Objetivo.toString():"")}
                            onChange={(e)=>setObjetivo(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Objetivos que se pretenden lograr durante la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                <div className="col">
                    <div className="mb-3">
                        <label htmlFor="alcance-plan" className="form-label">Alcance</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="alcance-plan" 
                            id="alcance-plan" 
                            rows={3} 
                            value={alcance}
                            title={alcance===""?"Doble click para cargar el alcance del plan anterior":""}
                            aria-describedby="helpId"
                            placeholder={plan?.Alcance?.slice(0,20)+"..."}
                            onDoubleClick={()=>setAlcance(plan?plan.Alcance.toString():"")}
                            onChange={(e)=>setAlcance(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Definir el alcance que comprende la auditoría planificada</small>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
            </div>

            <div
                className="row justify-content-center align-items-start g-2"
            >
                <div className="col">
                    <div className="mb-3">
                        <label htmlFor="criterios-plan" className="form-label">Criterios</label>
                        <textarea 
                            disabled={user.Auditoria!=="2"?true:false}
                            className="form-control" 
                            name="criterios-plan" 
                            id="criterios-plan" 
                            rows={3} 
                            value={criterios}
                            title={criterios===""?"Doble click para cargar los criterios del plan anterior":""}
                            aria-describedby="helpId"
                            placeholder={plan?.Criterios?.slice(0,20)+"..."}
                            onDoubleClick={()=>setCriterios(plan?plan.Criterios.toString():"")}
                            onChange={(e)=>setCriterios(e.target.value)}
                        ></textarea>
                        {
                            user.Auditoria==="2"?
                            <small id="helpId" className="form-text text-muted ocultar-al-imprimir">Definir los criterios que se implementarán durante la auditoría</small>
                            :
                            <div></div>
                        }
                    </div>
                    
                </div>
                {
                    user.Auditoria!=="0"?
                    <div className="col">
                        <div
                            className="table-responsive"
                        >
                            <h6>Equipo Auditor</h6>
                            <table
                                className="table table-striped table-hover table-borderless table-secondary align-top"
                            >
                                <thead className="table-success">
                                    <tr>
                                        <th>Apellido, Nombre</th>
                                        <th>Función</th>
                                        <th>
                                            {
                                                auditores[auditores.length-1]?.Id!==""?
                                                plan?.Id!==""?
                                                <button 
                                                    disabled={user.Auditoria!=="2"?true:false}
                                                    className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                                    title="Agregar Auditor"
                                                    onClick={nuevoAuditor}
                                                ><i className="bi bi-person-plus"></i>
                                                </button>
                                                :
                                                <div></div>
                                                :
                                                <div></div>
                                            }
                                            
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        auditores.map((auditor,key)=>(
                                            auditor.Id===""?
                                            <tr className="table-danger" key={key}>
                                                <td >
                                                    <input type="text" className="form-control" value={nombreNuevo} onChange={(e)=>setNombreNuevo(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" value={funcionNuevo} onChange={(e)=>setFuncionNuevo(e.target.value)}/>
                                                </td>
                                                <td >
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <button 
                                                            className="btn btn-sm btn-outline-success mx-1" 
                                                            onClick={guardarAuditor} 
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-floppy2-fill"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger mx-1" 
                                                            onClick={cancelarNuevoAuditor}
                                                            disabled={user.Auditoria!=="2"?true:false}
                                                        >
                                                            <i className="bi bi-trash-fill"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            :
                                            <tr className="table-secondary">
                                                <td >{auditor.Nombre}</td>
                                                <td >{auditor.Funcion}</td>
                                                <td >
                                                    <button 
                                                        className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                                        onClick={()=>eliminarAuditor(auditor.Id.toString())}
                                                        disabled={user.Auditoria!=="2"?true:false}
                                                    >
                                                        <i className="bi bi-trash-fill"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    
                                </tfoot>
                            </table>
                        </div>
                        
                    </div>
                    :
                    <div></div>
                }
                
            </div>

            <div
                className="table-responsive"
            >
                <h6>Cronograma de Actividades</h6>
                <table
                    className="table table-striped table-hover table-borderless table-success align-top"
                >
                    <thead className="table-success">
                        <tr>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Capítulo de la Norma</th>
                            <th>Tema / Prceso</th>
                            <th>Interlocutores</th>
                            <th>
                                {
                                    cronograma[cronograma.length-1]?.Id!==""?
                                    plan?.Id!==""?
                                    <button 
                                        className="btn btn-sm btn-outline-secondary ocultar-al-imprimir"
                                        title="Agregar Tarea"
                                        onClick={nuevoCronograma}
                                        disabled={user.Auditoria!=="2"?true:false}
                                    ><i className="bi bi-file-earmark-plus"></i>
                                    </button>
                                    :
                                    <div></div>
                                    :
                                    <div></div>
                                }
                            </th>
                        </tr>
                    </thead>
                    <tbody className="table-group-divider">
                        {
                            cronograma.map(cron=>(
                                cron.Id===""?
                                <tr
                                    className="table-secondary"
                                    key={cron.Id.toString()}
                                >
                                    <td >
                                        <input type="date" className="form-control" value={fechaNuevo} onChange={(e)=>setFechaNuevo(e.target.value)}/>
                                    </td>
                                    <td >
                                        <input type="time" className="form-control" value={horaNuevo} onChange={(e)=>setHoraNuevo(e.target.value)}/>
                                    </td>
                                    <td >
                                        <input type="text" className="form-control" value={capitulo_normaNuevo} onChange={(e)=>setCapitulo_normaNuevo(e.target.value)} />
                                    </td>
                                    <td >
                                        <input type="text" className="form-control" value={tema_procesoNuevo} onChange={(e)=>setTema_procesoNuevo(e.target.value)}/>
                                    </td>
                                    <td >
                                        <input type="text" className="form-control" value={interlocutoresNuevo} onChange={(e)=>setInterlocutoresNuevo(e.target.value)}/>
                                    </td>
                                    <td >
                                        <div className="d-flex justify-content-center align-items-center">
                                            <button 
                                                className="btn btn-sm btn-outline-success mx-1" 
                                                onClick={guardarCronograma}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-floppy2-fill"></i>
                                            </button>
                                            <button 
                                                className="btn btn-sm btn-outline-danger mx-1" 
                                                onClick={cancelarCronograma}
                                                disabled={user.Auditoria!=="2"?true:false}
                                            >
                                                <i className="bi bi-trash-fill"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                :
                                <tr
                                    className="table-secondary"
                                >
                                    <td >
                                        <input 
                                            type="date" 
                                            style={{backgroundColor:"transparent",border:"none",color:"black"}} 
                                            disabled 
                                            value={cron.Fecha.toString()}
                                        />
                                    </td>
                                    <td >{cron.Hora}</td>
                                    <td >{cron.Capitulo_norma}</td>
                                    <td >{cron.Tema_proceso}</td>
                                    <td >{cron.Interlocutores}</td>
                                    <td >
                                        <button 
                                            className="btn btn-sm btn-outline-danger mx-1 ocultar-al-imprimir" 
                                            onClick={()=>eliminarCronograma(cron.Id.toString())}
                                            disabled={user.Auditoria!=="2"?true:false}
                                        >
                                            <i className="bi bi-trash-fill"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                        
                    </tbody>
                    <tfoot>
                        
                    </tfoot>
                </table>
            </div>
            <hr />
            <div className="d-flex justify-content-center align-items-center mt-2">
                {
                    plan?.Id===""?
                    <button 
                        className="btn btn-outline-success ocultar-al-imprimir" 
                        onClick={guardarPlan}
                        disabled={user.Auditoria!=="2"?true:false}
                    >
                        Crear Plan de Auditoría
                    </button>
                    :
                    <button 
                        className="btn btn-outline-warning ocultar-al-imprimir" 
                        onClick={guardarPlan}
                        disabled={user.Auditoria!=="2"?true:false}
                    >
                        Actualizar Plan de Auditoría
                    </button>
                }
            </div>
            <hr className="ocultar-al-imprimir"/>
            <div
                className="alert alert-danger ocultar-al-imprimir"
                role="alert"
            >
                <h4 className="alert-heading">Eliminar Plan de Auditoría Interna Nº {plan?.Nro_auditoria}</h4>
                <p>Al eliminar el plan de auditoría se borrarán todos los datos relacionados de las bases de datos</p>
                <hr />
                <button 
                    className="btn btn-sm btn-outline-danger"
                    disabled={user.Auditoria!=="2"?true:false} 
                    onClick={plan?()=>eliminarPlan(plan.Id.toString()):()=>{}}
                >
                    Eliminar Plan
                </button>
            </div>
            

        </div>
    )
}